goog.provide("shadow.js.shim.module$$mui$material$FormControlLabel$default");
shadow.js.shim.module$$mui$material$FormControlLabel$default = shadow.js.shim.module$$mui$material$FormControlLabel.default;
